module.exports = __webpack_public_path__ + "static/media/Hero_Image_Tablet_1.67126327.jpg";